import React from 'react';

import s from './BottomRightCopyright.module.scss';

export const BottomRightCopyright: React.FC = () => (
  <div className={s.bottomRightCopyright}>
    <span>© Grid Singularity Pte Ltd</span>
  </div>
);
